export type LayoutKind = 'table' | 'seat' | 'stage' | 'zone' | 'candyBar' | 'other';
export interface LayoutElement {
  id: string; kind: LayoutKind; label: string; x: number; y: number;
  width: number; height: number; rotation: number; seats: number;
}
export interface LayoutDocument {
  width: number; height: number; capacity: number; elements: LayoutElement[];
}
export interface VenueLayout {
  document: LayoutDocument; version: number; sourceTemplateVersion: number | null;
  customerEditingEnabled: boolean; updatedAtUtc: string | null;
}
export const layoutKinds: Record<LayoutKind, string> = {
  table: 'Стіл', seat: 'Місце', stage: 'Сцена', zone: 'Зона', candyBar: 'Кенді-бар', other: 'Інше',
};
export function insideHall(e: LayoutElement, hall: LayoutDocument): boolean {
  const angle = e.rotation * Math.PI / 180;
  const hw = (Math.abs(Math.cos(angle)) * e.width + Math.abs(Math.sin(angle)) * e.height) / 2;
  const hh = (Math.abs(Math.sin(angle)) * e.width + Math.abs(Math.cos(angle)) * e.height) / 2;
  const cx = e.x + e.width / 2; const cy = e.y + e.height / 2;
  return cx - hw >= -1e-8 && cy - hh >= -1e-8 &&
    cx + hw <= hall.width + 1e-8 && cy + hh <= hall.height + 1e-8;
}
export function validateLayout(hall: LayoutDocument): string | null {
  const dimension = (n: number) => Number.isFinite(n) && n >= 0.1 && n <= 100;
  if (!dimension(hall.width) || !dimension(hall.height) || !Number.isInteger(hall.capacity) ||
      hall.capacity < 1 || hall.capacity > 5000 || hall.elements.length > 300)
    return 'Перевірте розміри залу (0,1–100 м), місткість (1–5000) і кількість елементів (до 300).';
  const ids = new Set<string>();
  for (const e of hall.elements) {
    if (!e.id || ids.has(e.id) || !layoutKinds[e.kind] || !e.label.trim() || e.label.length > 120 ||
        !dimension(e.width) || !dimension(e.height) || !Number.isFinite(e.x) || !Number.isFinite(e.y) ||
        !Number.isFinite(e.rotation) || e.rotation < 0 || e.rotation >= 360 ||
        !Number.isInteger(e.seats) || e.seats < 0 || e.seats > 500 ||
        (e.kind === 'seat' && e.seats !== 1) ||
        (!['table', 'seat'].includes(e.kind) && e.seats !== 0))
      return 'Перевірте назви, розміри, поворот і місця елементів.';
    ids.add(e.id);
    if (!insideHall(e, hall)) return 'Елемент із урахуванням повороту має бути всередині залу.';
  }
  return hall.elements.reduce((sum, e) => sum + e.seats, 0) > hall.capacity
    ? 'Кількість місць перевищує місткість залу.' : null;
}
